'use strict';

module.exports = {
  NONE: 0,
  ALL: 1,
  PLACES: 8,
  SENTIMENT: 16,
  DEMOGRAPHICS: 32,
  RADIO: 64,
  PLACES_VALIDATION: 128,
  PLACES_ENRICHMENT: 256,
  DATA_UPLOAD: 512,
  PLACES_EXPORTS: 1024,
  RADIO_EXPORTS: 2048,
  OSM_ACCESS: 4096,
  SIGNALS: 8192,
  DATA_UPLOAD_VIEWER: 16384,

  has: (v, f) => (v & module.exports.ALL) > 0 || (v & f) > 0,
  set: (v, f) => v | f,
  list: function (v) {
    const features = Object.keys(this).filter((d) => !isNaN(this[d]) && v & this[d]);
    return features.length > 0 ? features : ['NONE'];
  },
  print: function (v) {
    console.log(JSON.stringify(this.list(v), null, ' '));
  },
  name: function (v) {
    const features = Object.keys(this).filter((d) => !isNaN(this[d]) && +v === this[d]);
    return features[0];
  }
};
